import React from 'react';
import { Typography, Grid, makeStyles, Container, Button } from '@material-ui/core';

import DetailsForm from './DetailsForm';
import PasswordForm from './PasswordForm';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));


function Account(props) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container className={classes.root} maxWidth='lg'>
      <div className={classes.header}>
        <Typography variant="h4">
          Account
        </Typography>

        <Button
          variant='outlined'
          onClick={() => history.push('/')}
        >
          Home
        </Button>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <DetailsForm />
        </Grid>

        <Grid item xs={12} sm={6}>
          <PasswordForm />
        </Grid>
      </Grid>
    </Container>
  )
}

export default Account;
